// Whether the navbar should show GET PRO+. Everyone who is not currently
// entitled to PRO or PRO+ sees it, signed in or not — the signed-out visitor is
// the one the upsell is most for. Hidden while the user lookup is in flight so
// a subscriber never sees it flash. The mobile off-canvas menu applies the same
// rule server-side in NavHelper#show_pro_upsell?.
export const proUpsellVisible = ({ loading, isProOrProPlus }: { loading: boolean; isProOrProPlus: boolean }): boolean =>
  !loading && !isProOrProPlus;
